import React from 'react';

const Footer = () => (
  <footer className="container mx-auto py-16 px-3 mt-48 mb-8 text-gray-800">
    <div className="flex -mx-3">
      <div className="flex-1 px-3">
        <h2 className="text-lg font-semibold">Inflybo LLC</h2>
        <p className="mt-5">All-in-one platform to manage your VIP Lounges.</p>
        <p className="mt-5">1309 Coffeen Avenue STE 1200</p>
        <p className="mt-1">Sheridan, WY 82801</p>
        <p className="mt-5">info@inflybo.com</p>
      </div>
      <div className="flex-1 px-3">
        <h2 className="text-lg font-semibold">Important Links</h2>
        <ul className="mt-4 leading-loose">
          <li>
            <a href="https://www.iubenda.com/privacy-policy/45150955">Privacy Policy</a>
          </li>
          <li>
            <a href="https://www.iubenda.com/privacy-policy/45150955/cookie-policy">Cookies</a>
          </li>
        </ul>
      </div>
      <div className="flex-1 px-3">
        <h2 className="text-lg font-semibold">Social Media</h2>
        <ul className="mt-4 leading-loose">
          <li>
            <a href="https://twitter.com/inflybo" target="_blank">Twitter</a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/inflybo" target="_blank">LinkedIn</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
);

export default Footer;
